import React from 'react';
import classNames from 'classnames';

import styles from './Spinner.module.scss';

export const Spinner: React.FC<{ rounded?: boolean , isLogin?: boolean }> = ({ rounded, isLogin }) => (
  <div
    className={classNames({
      [styles.isLoginSpinner]:isLogin,
      [styles.spinner]: !rounded,
      [styles.rounded]: rounded,
    })}
  />
);